'use client';

import React from 'react';
import styles from './ready-animation.module.css';
export const TriviaGameReadyAnimation = () => {
  return (
    <>
      <div className="flex flex-col items-center">
        <div className={styles.demo}>
          <div className={styles.coloredBlock}>
            <div className={styles.rotater}>
              <div className={styles.coloredBlockChild} />
              <div className={styles.coloredBlockChild} />
              <div className={styles.coloredBlockChild} />
            </div>
            <div className={styles.coloredBlockInner} />
          </div>
          <div className={styles.demoInner}>
            <svg className={styles.demoNumbers} viewBox="0 0 100 100">
              <path
                className={styles.demoNumbersPath}
                d="M-10,20 60,20 40,50 a18,15 0 1,1 -12,19
               Q25,44 34.4,27.4
               l7,-7 a16,16 0 0,1 22.6,22.6 l-30,30 l35,0 L69,73
               a20,10 0 0,1 20,10 a17,17 0 0,1 -34,0 L55,83
               l0,-61 L40,28"
              />
            </svg>
          </div>
        </div>
        <svg
          width="0"
          height="0"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
        >
          <defs>
            <linearGradient id="MyGradient">
              <stop offset="5%" stopColor="#fcfcff" />
              <stop offset="95%" stopColor="rgba(166, 172, 220, 0.68)" />
            </linearGradient>
          </defs>
        </svg>
      </div>
    </>
  );
};
